/* eslint-disable no-debugger */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './Splash.scss';
import { logopath } from '@/configs/appConfig';

const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState<string>('Yükleniyor...');
  const [isExtracting, setIsExtracting] = useState(false);
  const [progress, setProgress] = useState({
    current: 0,
    total: 0,
    percentage: 0,
  });

  const navigateBooks =() => {
    setTimeout(()=> {

      navigate('/books')
    }, 1000)
  }

  useEffect(() => {
    navigateBooks()
  }, []);


  return (
    <div className="splash-container">
      <img src={logopath} alt="Logo" className="logo" />

      <div className="loading-content">
        {isExtracting ? (
          <>
            <div className="extracting-animation">
              <div className="book-loader">
                <div className="book-page"></div>
                <div className="book-page"></div>
                <div className="book-page"></div>
              </div>
            </div>

            {progress.total > 0 && (
              <div className="progress-info">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${progress.percentage}%` }}
                  />
                </div>
                <div className="progress-text">
                  {progress.current} / {progress.total} dosya
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="loader-circle"></div>
        )}

        <div className="status-text">
          {isExtracting && (
            <svg
              className="extracting-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2V6M12 18V22M6 12H2M22 12H18M19.07 19.07L16.24 16.24M19.07 5.93L16.24 8.76M4.93 19.07L7.76 16.24M4.93 5.93L7.76 8.76"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          <span>{status}</span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
